
import Vue from 'vue';
import updateMixin from '@/mixins/update';
import { ACTIONS } from './constants/actions';
import Snackbar from '@/components/snackbar/Snackbar.vue';
import _ from 'lodash';
import { APP_VUEX_MODULES } from './constants/vuex-modules';
import { MUTATIONS } from './constants/mutations';
import { Route } from 'vue-router';
import ChooseBookingPageToUpgradeDialog from './components/dialogs/ChooseBookingPageToUpgradeDialog.vue';
import { LayoutDirection } from './utils/types.util';
import { AppPossibleLanguages } from './enums/app-possible-languages.enum';

export default Vue.extend({
  name: 'App',
  components: { Snackbar, ChooseBookingPageToUpgradeDialog },
  mixins: [updateMixin],
  data(): any {
    return {
      debouncedResizeEventHandler: null
    };
  },
  created(): void {
    this.initApplication();
    this.debouncedResizeEventHandler = _.debounce(this.resizeHandler, 100);
    window.addEventListener('resize', this.debouncedResizeEventHandler);
  },
  destroyed(): void {
    window.removeEventListener('resize', this.debouncedResizeEventHandler);
  },
  methods: {
    initApplication(): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.ui.initAppLanguageAndLayout).then(
        ({
          layoutDirection,
          language
        }: {
          layoutDirection: LayoutDirection;
          language: AppPossibleLanguages;
        }) => {
          this.getAvailableLanguages();
          this.setAppLayoutDirection(layoutDirection);
          this.setAppLanguage(language);
        }
      );
    },
    getAvailableLanguages(): void {
      const { dispatch } = this.$store;
      dispatch(ACTIONS.ui.fetchLanguages);
    },
    setAppLayoutDirection(dir: LayoutDirection): void {
      this.$vuetify.rtl = dir === 'rtl';
    },
    setAppLanguage(language: AppPossibleLanguages): void {
      this.$i18n.locale = language;
      this.updateMetaTags();
    },
    updateMetaTags(): void {
      document.title = this.$tc('documentTitle');
      const description = document.querySelector('[name="description"]');
      const ogTitle = document.querySelector('[property="og:title"]');
      const ogDescription = document.querySelector('[property="og:description"]');
      description?.setAttribute('content', this.$tc('documentDescription'));
      ogTitle?.setAttribute('content', this.$tc('documentTitle'));
      ogDescription?.setAttribute('content', this.$tc('documentDescription'));
    },
    resizeHandler(): void {
      if (screen.width < 991) {
        const { commit } = this.$store;
        commit(APP_VUEX_MODULES.ui + '/' + MUTATIONS.ui.setBookingListLayoutToRows);
      }
    }
  },
  watch: {
    $route(to: Route) {
      // reset alert state on route change
      this.$store.dispatch(ACTIONS.alert.clear);
      if (to) {
        this.$store.dispatch(ACTIONS.drawer.updateDrawerListUi, { item: to.name });
      }
    }
  }
});
